import React, { Component } from 'react'
class DragAndDrop extends Component {


    /*
    max_size: 2 (MB),
    handleDrop: => returns files,
    className: class,
    format: ['pdf', 'png', ...],
    * */

    constructor(props){
        super(props);
        this.state = {
            drag: false,
            max_size: 256,
        };

        this.dropRef = React.createRef();
        this.inputRef = React.createRef();
        this.dragCounter = 0;
    }


    handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragIn = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({drag: true});
        }
    };

    handleDragOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter === 0) {
            this.setState({drag: false});
        }
    };
    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({drag: false});
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            this.notifyUpload(e.dataTransfer.files);
            e.dataTransfer.clearData();
            this.dragCounter = 0;
        }
    };

    notifyUpload = (files) =>{
        let format = files['0']['name'].split('.');
        format = format[format.length-1].toLowerCase();

        const fit_size = (files['0']['size'] / 1000000) <= this.state.max_size;

        const valid = this.props.format.includes(format) && fit_size;

        if (valid) {
            this.props.handleDrop(files);
        } else if (!fit_size) {
            this.props.handleDrop('קובץ גדול מידי, יש להזין קובץ עד ' + this.state.max_size + ' MB');
        } else {
            this.props.handleDrop('שגיאה בהעלאת הקובץ');
        }
    };

    componentDidMount() {
        let div = this.dropRef.current;
        div.addEventListener('dragenter', this.handleDragIn);
        div.addEventListener('dragleave', this.handleDragOut);
        div.addEventListener('dragover', this.handleDrag);
        div.addEventListener('drop', this.handleDrop);

        if('max_size' in this.props){
            this.setState({max_size: this.props.max_size});
        }
    }
    componentWillUnmount() {
        let div = this.dropRef.current;
        div.removeEventListener('dragenter', this.handleDragIn);
        div.removeEventListener('dragleave', this.handleDragOut);
        div.removeEventListener('dragover', this.handleDrag);
        div.removeEventListener('drop', this.handleDrop);
    }
    render() {
        const {label = 'בחר'} = this.props;
        return (
            <div
                className={this.props.className + ' dragAndDrop ' + (this.state.drag ? 'drag' : '')}
                style={{display: 'inline-block', position: 'relative'}}
                ref={this.dropRef}>

                <div>{this.props.placeholder}</div>
                <div className='input-wrapper'>
                    <span className='label'>{label}</span>
                    <input type='file' className='input-file' ref={this.inputRef} onInput={()=>{this.notifyUpload(this.inputRef.current.files)}}/>
                </div>
                {this.props.children}
            </div>
        )
    }
}
export default DragAndDrop
